import React from 'react';
import { UiGrid, UiGridProps } from '@open-stack/ui';
import clsx from 'clsx';
import './XCard.scss';

export function XCard({ className, ...rest }: UiGridProps) {
    rest.gap = rest.gap ?? 0;
    return <UiGrid className={clsx('XCard', className)} {...rest} />;
}
